export const scrollToSelector = (
  parentSelector,
  targetSelector,
  offsetTop = 0,
) => {
  const main = document.querySelector(parentSelector)

  main?.scrollTo({
    top: document.querySelector(targetSelector)?.offsetTop - offsetTop,
    left: 0,
    behavior: 'smooth',
  })
}

export const scrollToViewSelector = (aim, block = 'start') => {
  const main = document.querySelector(aim)

  main?.scrollIntoView({
    behavior: 'smooth',
    block: block,
  })
}

export const nlpScrollToViewSelector = (aim, offset = 0) => {
  const main = document.querySelector(aim)

  if (main) {
    setTimeout(() => {
      const top = main.getBoundingClientRect().top + window.pageYOffset + offset

      window.scrollTo({
        top,
        behavior: 'smooth'
      })
    }, 0)
  }
}

export const nlpScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export const getOffsetTopInContainer = (el, container) => {
  if (!el || !container) return 0
  const elRect = el.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()
  return elRect.top - containerRect.top + container.scrollTop
}
